export default __webpack_public_path__ + "static/media/MainColorLogo.98681692.svg";